import { useEffect } from 'react';
import { useMatch, useSearchParams } from 'react-router-dom';

import {
  isLegacyPlayer,
  LEGACY_PLAYER,
  PLAYER_PARAM,
  setLegacyPlayer,
} from 'src/utils/playerVersion';

export function usePlayerVersion() {
  const [searchParams, setSearchParams] = useSearchParams();
  // From the url, not the store: the loaded rundown lags a navigation.
  const rundownId = useMatch('/rundown/:rundownId')?.params.rundownId;
  const param = searchParams.get(PLAYER_PARAM);
  const isLegacy = param === LEGACY_PLAYER;

  // The param states the mode; storage remembers it per rundown.
  useEffect(() => {
    if (!rundownId) return;

    if (param === null) {
      if (isLegacyPlayer(rundownId)) {
        searchParams.set(PLAYER_PARAM, LEGACY_PLAYER);
        setSearchParams(searchParams, { replace: true });
      }
      return;
    }

    setLegacyPlayer(rundownId, isLegacy);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [param, rundownId]);

  const setLegacy = (next: boolean) => {
    if (next) {
      searchParams.set(PLAYER_PARAM, LEGACY_PLAYER);
    } else {
      searchParams.delete(PLAYER_PARAM);
    }

    if (rundownId) setLegacyPlayer(rundownId, next);
    setSearchParams(searchParams);
  };

  return { isLegacy, setLegacy };
}
